module.exports = __webpack_public_path__ + "public/adminIcons/ManageAdmin.svg?02dae3c6";